.footer {
    height: 100px;
}